import axiosInstance from "../../../../axiosInstance";
import { success, error, info } from "../../../../store/notification/actions";

export const getPricingPlanModules = () => {
  info("Loading Pricing Modules...");
  return axiosInstance
    .get(`/pricing/getPricingPlanModules`, {})
    .then((res) => {
      if (res.data.status === "success" && res.data) {
        success('Loaded successfully !!!');
        return { message: "", hasError: false, data: res.data };
      } else {
        return { message: "No records found.", hasError: true, data: "" };
      }
    })
    .catch((err) => {
      error(err.response.error[0].message);
      return {
        message: err.response.error[0].message,
        hasError: true,
        data: "",
      };
    });
};
